import React, { useState } from 'react';

const FAQSection = ({ faqs = [], title = 'Frequently Asked Questions' }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const defaultFAQs = [
    {
      question: 'What is required to become a seller?',
      answer:
        'You need a valid mobile number, PAN or GST number, business address, and bank account details to register as a seller.',
    },
    {
      question: 'How long does the registration process take?',
      answer:
        'The registration process typically takes 5-10 minutes. After submission, your account will be verified within 24 hours.',
    },
    {
      question: 'What if I do not have a GST number?',
      answer:
        'You can still register using your PAN number and apply for an Enrolment ID/UIN. You can also apply for GST later.',
    },
    {
      question: 'Is there any registration fee?',
      answer: 'No, registration is completely free. There are no upfront charges.',
    },
  ];

  const displayFAQs = faqs.length > 0 ? faqs : defaultFAQs;

  return (
    <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>

      <div className="space-y-3">
        {displayFAQs.map((faq, index) => {
          const isExpanded = expandedIndex === index;
          return (
            <div
              key={index}
              className="rounded-xl border border-gray-200 bg-gray-50 shadow-sm"
            >
              <button
                onClick={() =>
                  setExpandedIndex(isExpanded ? null : index)
                }
                className="w-full px-4 py-3 flex items-center justify-between text-left text-sm font-semibold text-gray-800"
              >
                <span>{faq.question}</span>
                <svg
                  className={`w-5 h-5 text-gray-500 transition-transform ${
                    isExpanded ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {isExpanded && (
                <div className="px-4 pb-4 text-sm text-gray-600 border-t border-gray-200 bg-white rounded-b-xl">
                  {faq.answer}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQSection;
